

































































import { Component, Emit, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { InputCodeAndTextField } from '@/components/molecules/InputCodeAndTextField'
import CODE_KEY from '@/config/code_key'
import { defaultSystemCode, SystemCode } from '@/api'
import { systemCodeStore } from '@/utils/store-accessor'
import { InputCode } from '@/components/molecules/InputCode'

export interface InputOfReserveContactSituationReserveContactInfoItem {
  reserveContactComplete: {
    input: boolean
  }
  hasReserveExpiration: boolean
  reserveExpiration: {
    input: string
    errorMessage: string
  }
  displayMemo: {
    input: string
    errorMessage: string
    text: string
  }
}

export const defaultInputOfReserveContactSituationReserveContactInfoItem = (): InputOfReserveContactSituationReserveContactInfoItem => ({
  reserveContactComplete: {
    input: true
  },
  hasReserveExpiration: false,
  reserveExpiration: {
    input: '',
    errorMessage: ''
  },
  displayMemo: {
    input: '',
    errorMessage: '',
    text: ''
  }
})

@Component({
  components: {
    InputCode,
    InputCodeAndTextField,
    InputDatePicker
  }
})
export default class InputOfReserveContactSituationReserveContactInfo extends ComponentVue {
  @PropSync('inputItem', {
    type: Object,
    required: true
  })
  item!: InputOfReserveContactSituationReserveContactInfoItem

  get systemCodeOfReserveNote(): SystemCode {
    return (
      systemCodeStore.findByCodeKeyAndCode(
        CODE_KEY.RESERVE_NOTE.KEY,
        this.item.displayMemo.input
      ) ?? defaultSystemCode()
    )
  }

  onClickReserveNoteCodeKeyList(): void {
    this.$modalCode.open({
      codeKey: CODE_KEY.RESERVE_NOTE.KEY,
      title: CODE_KEY.RESERVE_NOTE.NAME,
      defaultCode: this.item.displayMemo.input,
      onOkClick: (item: SystemCode | null) => {
        this.setDisplayMemoCodeKey(item?.code ?? '')
        this.onInputDisplayMemoText(item?.name ?? '')
      }
    })
  }

  setDisplayMemoCodeKey(value: string): void {
    this.item.displayMemo.input = value
    this.item.displayMemo.errorMessage = ''

    if (value === '') {
      this.item.displayMemo.text = ''
      return
    }

    if (this.systemCodeOfReserveNote.name) {
      this.item.displayMemo.text = this.systemCodeOfReserveNote.name
    }
  }

  onInputDisplayMemoText(value: string): void {
    this.item.displayMemo.text = value
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('reserve-expiration-icon')
  onClickIconOfReserveExpiration(): void {}
}
